import { render, staticRenderFns } from "./BaseButton.vue?vue&type=template&id=2f8582ce&scoped=true&"
import script from "./BaseButton.vue?vue&type=script&lang=ts&"
export * from "./BaseButton.vue?vue&type=script&lang=ts&"
import style0 from "./BaseButton.vue?vue&type=style&index=0&id=2f8582ce&lang=scss&scoped=true&"
import style1 from "./BaseButton.vue?vue&type=style&index=1&id=2f8582ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f8582ce",
  null
  
)

export default component.exports